module.exports = __webpack_public_path__ + "assets/img/20_1056_big.cfb6f7e2.jpg";